<template>
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
    <el-form-item prop="age">
      <el-input prefix-icon="el-icon-user" v-model="ruleForm.age"></el-input>
    </el-form-item>
    <el-form-item prop="pass">
      <el-input
        prefix-icon="el-icon-lock"
        type="password"
        v-model="ruleForm.pass"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button class="button_click" type="primary" @click="submitForm('ruleForm')">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'));
      }
      callback();
      // setTimeout(() => {
      //   if (!Number.isInteger(value)) {
      //     callback(new Error("请输入数字值"));
      //   } else {
      //     if (value < 18) {
      //       callback(new Error("必须年满18岁"));
      //     } else {
      //       callback();
      //     }
      //   }
      // }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        pass: '',
        age: '',
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        age: [{ validator: checkAge, trigger: 'blur' }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      const _this = this;

      this.$refs[formName].validate(valid => {
        if (valid) {
          const { pass, age } = this.ruleForm;
          console.log(this.$sha256(pass))
          this.$http
            .post(this.$userList.user_login_subUser, {
              password: this.$sha256(pass.toString()),
              user_name: age.toString(),
            })
            .then(
              res => {
                console.log(res);
                if (res.code === 200) {
                  localStorage.setItem('KC_token', res.data.token);
                  // localStorage.setItem(
                  //   'KC_restaurant_id',
                  //   JSON.stringify(res.restaurants[0].id)
                  // );

                  // localStorage.setItem(
                  //   'KC_restaurants',
                  //   JSON.stringify(res.restaurants)
                  // );
                  // localStorage.setItem('KC_roles', JSON.stringify(res.roles));
                  console.log(res.data.token);
                  if (res.data.token) {
                    this.$emit('radioListS');
                  }
                } else {
                  if (res.message) {
                    _this.$alert(res.message);
                  }
                }
                console.log(res);
              },
              res => {
                console.info(res, '调用失败');
              }
            );
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.button_click {
  width: 100%;
  background: #1890ff;
}
</style>
